import React from 'react'
import SurveyListSidebar from '../layout/SurveyListSidebar'
import { Outlet } from 'react-router'
import SurveyListHeader from '../layout/SurveyListHeader'

const AdminSurveyLayout = () => {
    return (
        <div className='d-flex flex-column main-outer-wrapper'>
            <SurveyListHeader />
            {/* <SubHeader title={'Digital Maturity Survey'} /> */}
            <div className="flex-grow-1 d-flex survey-main-wrapper">
                <SurveyListSidebar />
                <Outlet />
            </div>
        </div>
    )
}

export default AdminSurveyLayout